/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Read progress for the operation, reporting records processed and, where available, the estimated total. Present for all read operations.
 * @export
 * @interface OperationMetadataProgress
 */
export interface OperationMetadataProgress {
    /**
     * 
     * @type {string}
     * @memberof OperationMetadataProgress
     */
    installationId?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationMetadataProgress
     */
    objectName?: string;
    /**
     * 
     * @type {string}
     * @memberof OperationMetadataProgress
     */
    operationId?: string;
    /**
     * 
     * @type {number}
     * @memberof OperationMetadataProgress
     */
    recordsProcessed?: number;
    /**
     * Only present for some providers (e.g. Salesforce, HubSpot).
     * @type {number}
     * @memberof OperationMetadataProgress
     */
    recordsEstimatedTotal?: number;
}

/**
 * Check if a given object implements the OperationMetadataProgress interface.
 */
export function instanceOfOperationMetadataProgress(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OperationMetadataProgressFromJSON(json: any): OperationMetadataProgress {
    return OperationMetadataProgressFromJSONTyped(json, false);
}

export function OperationMetadataProgressFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperationMetadataProgress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'installationId': !exists(json, 'installationId') ? undefined : json['installationId'],
        'objectName': !exists(json, 'objectName') ? undefined : json['objectName'],
        'operationId': !exists(json, 'operationId') ? undefined : json['operationId'],
        'recordsProcessed': !exists(json, 'recordsProcessed') ? undefined : json['recordsProcessed'],
        'recordsEstimatedTotal': !exists(json, 'recordsEstimatedTotal') ? undefined : json['recordsEstimatedTotal'],
    };
}

export function OperationMetadataProgressToJSON(value?: OperationMetadataProgress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'installationId': value.installationId,
        'objectName': value.objectName,
        'operationId': value.operationId,
        'recordsProcessed': value.recordsProcessed,
        'recordsEstimatedTotal': value.recordsEstimatedTotal,
    };
}

